import { MenuItem } from '@/types';

/**
 * Root / top level side navigation menu
 */
export const rootSideMenu: MenuItem[] = [
  { label: 'Home', path: '/' },
  { label: 'Getting Started', path: '/getting-started' },
  { label: 'SDK Reference', path: '/sdk_ref' },
  { label: 'How-To', path: '/knowledge-base/how-to' },
  { label: 'Troubleshooting', path: '/knowledge-base/troubleshooting' },
  { label: 'FAQs', path: '/knowledge-base/faqs' },
  { label: 'Reference', path: '/knowledge-base/reference' },
  { label: 'Glossary', path: '/glossary/phenix-glossary-of-terms' },
];
